<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record
        title="Personal"
        resource="personal"
        primaryKey="idpersonal"
        :record="record"
        :columns="columns"
        @saveChanges="handleSave"
        :service="service"
        :readonly="readonly"
      />
    </div>
    <div class="w-full mb-12 px-4" v-if="!isNew && puedeVerDetalle">
      <div
        class="text-sm font-medium text-center text-gray-500 border-b border-gray-200 mb-3"
      >
        <ul
          class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200"
        >
          <li class="me-2">
            <button
              @click="openTab('calendario')"
              class="inline-block p-4 rounded-t-lg"
              :class="[
                tabName === 'calendario'
                  ? 'active text-blue-600 bg-gray-100'
                  : 'hover:text-gray-600 hover:bg-gray-50',
              ]"
            >
              {{ $t("Calendario") }}
            </button>
          </li>
          <li class="me-2">
            <button
              @click="openTab('horasPorProyecto')"
              class="inline-block p-4 rounded-t-lg"
              :class="[
                tabName === 'horasPorProyecto'
                  ? 'active text-blue-600 bg-gray-100'
                  : 'hover:text-gray-600 hover:bg-gray-50',
              ]"
            >
              {{ $t("Horas por proyecto") }}
            </button>
          </li>
          <li class="me-2" v-if="isAdmin">
            <button
              @click="openTab('costosPorHora')"
              class="inline-block p-4 rounded-t-lg"
              :class="[
                tabName === 'costosPorHora'
                  ? 'active text-blue-600 bg-gray-100'
                  : 'hover:text-gray-600 hover:bg-gray-50',
              ]"
            >
              {{ $t("Costos por hora") }}
            </button>
          </li>
        </ul>
      </div>
      <card-scheduler
        subtitle="Horas del personal"
        :idpersonal="idpersonal"
        v-if="tabName === 'calendario'"
      />
      <ProyectosPorPersonal
        v-if="tabName === 'horasPorProyecto'"
        :idpersonal="idpersonal"
      />
      <card-list
        v-if="tabName === 'costosPorHora' && isAdmin"
        title="Costos por hora"
        resource="directo_horas"
        primaryKey="iddirecto_hora"
        :records="directoHoras"
        :meta="directoHorasMeta"
        :columns="directoHorasColumns"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CardList from "@/components/Cards/CardList.vue";
import CardRecord from "@/components/Cards/CardRecord.vue";
import CardScheduler from "@/components/Cards/CardScheduler.vue";
import ProyectosPorPersonal from "@/views/admin/ProyectosPorPersonal.vue";
import PersonalService from "@/services/personal.service";
import Directo_horaService from "@/services/directo_hora.service";
import { personal } from "@/models/personal";
import { directo_hora } from "@/models/directo_hora";

export default {
  components: {
    CardList,
    CardRecord,
    CardScheduler,
    ProyectosPorPersonal,
  },

  data() {
    return {
      record: {},
      // El backend decide si esta ficha es visible: si no lo es, no se muestran
      // las pestañas ni se consultan sus reportes. No se replica aca la regla
      // de jerarquia/empresa para no tener dos versiones que puedan divergir.
      //
      // Arranca en false a proposito: si arrancara en true, las pestañas
      // montarian antes de que llegue la respuesta y el calendario alcanzaria
      // a pedir las horas de alguien que no corresponde.
      puedeVerDetalle: false,
      columns: personal,
      service: PersonalService,
      tabName: "calendario",
      directoHoras: {},
      directoHorasMeta: {},
      directoHorasColumns: directo_hora.filter(
        (column) => column.showOnList && column.name !== "idpersonal",
      ),
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.auth.user,
    }),

    idpersonal() {
      return this.$route.params.id;
    },

    isNew() {
      return this.idpersonal == "new";
    },

    readonly() {
      const roles = this.userInfo?.roles || [];
      return !roles.includes("admin") && !roles.includes("personal");
    },

    isAdmin() {
      return this.userInfo?.roles?.includes("admin");
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        this.puedeVerDetalle = false;

        PersonalService.get(this.idpersonal)
          .then((data) => {
            if (!data?.record) {
              return;
            }
            this.record = data.record;
            this.puedeVerDetalle = true;
            this.loadCurrentTab();
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    },

    openTab(newTabName) {
      this.$router.push({ query: {} })
        .catch(() => {})
        .then(() => {
          this.tabName = newTabName;
          this.loadCurrentTab();
        });
    },

    loadCurrentTab() {
      if (this.isNew) return;
      if (this.tabName === "costosPorHora" && this.isAdmin) {
        this.loadDirectoHoras();
      }
    },

    loadDirectoHoras() {
      const params = { ...this.$route.query };
      const directoHoraFilters = JSON.parse(params.filters || "{}");
      directoHoraFilters.idpersonal = {
        value: this.idpersonal,
        type: "personal",
      };
      params.filters = JSON.stringify(directoHoraFilters);

      Directo_horaService.list(params)
        .then((data) => {
          this.directoHoras = data.records;
          this.directoHorasMeta = data.meta;
        })
        .catch((response) => {
          console.log(response);
        });
    },
  },
};
</script>
